<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon bookmark-icon"
    :class="{ active: isFavorite }"
    viewBox="0 0 24 24"
    @click.stop="$emit('toggle-favorite')"
  >
    <path
      d="M17.5282 20.6437L12.0266 16.2644L6.52492 20.6437C5.62126 21.3525 4 20.8968 4 19.9349V4.49351C4 3.65816 4.69103 3 5.51495 3H18.485C19.3355 3 20 3.65816 20 4.49351V19.9349C20 20.8968 18.3787 21.3778 17.4751 20.6437H17.5282Z"
    />
  </svg>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({ isFavorite: Boolean });

const isFavorite = computed(() => props.isFavorite);
</script>

<style scoped lang="scss">
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  flex-shrink: 0;

  cursor: pointer;
  fill: $gray50;
  transition: fill 0.3s ease;
}

.icon.active {
  fill: $color-gray-700;
}
</style>
